import React from 'react';
import VisibilitySensor from '../../../../common/VisibilitySensor';

import {
  HeroWrapper,
  HeroHeadline,
  HeroLabel,
  BGImage,
  HeroBg,
} from './index.styles';

const Hero = () => (
  <HeroWrapper className="hero">
    <div className="container-fluid container-fluid--sitewidth">
      <div className="row justify-content-center pb-sm-5 pb-lg-3 pt-xl-2">
        <div className="col-lg-5 offset-lg-1 col-sm-6 py-5 align-self-center hero__caption">
          <HeroHeadline className="fs-h1 mb-4 text-white font-weight-bold hero__headline pr-5">
            Giving financial professionals the power to{' '}
            <HeroLabel className="hero__headline__label">simplify</HeroLabel>
          </HeroHeadline>
          <h2 className="fs-h2 font-weight-normal text-white pr-md-5">
            Set up 401(k) plans for small businesses without investing a lot of
            time and resources.
          </h2>
        </div>
        <div className="col-sm-5"></div>
      </div>
    </div>
    <VisibilitySensor offset={{ top: 400 }}>
      {({ isVisible }) => (
        <BGImage className={isVisible ? '' : 'animate'}>
          <HeroBg />
        </BGImage>
      )}
    </VisibilitySensor>
  </HeroWrapper>
);

export default Hero;
